// Owner: P1 piece 4 "Organisation page" (docs/FILE-OWNERSHIP.md).
// The feature's entry file (docs/CONTRACTS.md section 16): the table at /orgs and the page at /orgs/$orgnr, each a lazy
// chunk. The paths carry the organisation number and filter codes only (never free text).
import { createRoute, lazyRouteComponent } from '@tanstack/react-router'
import { Building2 } from 'lucide-react'
import type { Feature } from '../feature.ts'
import { parseFilters } from './search.ts'

export const feature: Feature = {
  app: (parent) => [
    createRoute({
      getParentRoute: () => parent,
      path: '/orgs',
      validateSearch: (search: Record<string, unknown>) => parseFilters(search),
      component: lazyRouteComponent(() => import('./OrgsScreen.tsx')),
    }),
    createRoute({
      getParentRoute: () => parent,
      path: '/orgs/$orgnr',
      component: lazyRouteComponent(() => import('./OrgScreen.tsx')),
    }),
  ],
  nav: [{ to: '/orgs', label: 'nav.organisations', icon: Building2, group: 'work', key: 'o' }],
}
